import React from 'react'
import { Button, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import { useModalStore } from '../../store/ModalStore'
import { MODAL_STATE } from '../../types/modals'

import './Founders.css'

const { Title, Paragraph } = Typography

const Founders = () => {
    const { t } = useTranslation()
    const { openModal } = useModalStore()

    return (
        <div className="about-content">
            <div className="about-text">
                <Title className="title" level={2}>
                    {t('about.founders.title')}
                </Title>
                <Paragraph className="paragraph">
                    {t('about.founders.description')}
                </Paragraph>
                <Button
                    type="primary"
                    size="large"
                    className="about-button"
                    onClick={() => openModal(MODAL_STATE.CONTACT_US)}
                >
                    {t('about.founders.contactUs')}
                </Button>
            </div>

            <div className="about-image-card">
                <img
                    className="about-image"
                    src="/img/founders.png"
                    alt={t('common.alt.founders')}
                />
            </div>
        </div>
    )
}

export default Founders
